import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoadingState {
  postLoading: boolean;
  commentLoading: boolean;
  userLoading: boolean;
  draftLoading: boolean;
  draftLoadingType: "posts" | "articles" | null;

  editingPost: {
    loading: boolean;
    postId: string | null;
  };
}

const initialState: LoadingState = {
  postLoading: false,
  commentLoading: false,
  userLoading: false,
  draftLoading: false,
  draftLoadingType: null,

  editingPost: {
    loading: false,
    postId: null,
  },
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setPostLoading: (state, action: PayloadAction<boolean>) => {
      state.postLoading = action.payload;
    },
    setCommentLoading: (state, action: PayloadAction<boolean>) => {
      state.commentLoading = action.payload;
    },
    setUserLoading: (state, action: PayloadAction<boolean>) => {
      state.userLoading = action.payload;
    },
    setDraftLoading: (
      state,
      action: PayloadAction<{
        loading: boolean;
        type: "posts" | "articles" | null;
      }>
    ) => {
      state.draftLoading = action.payload.loading;
      state.draftLoadingType = action.payload.type;
    },
    setEditingPostLoading: (
      state,
      action: PayloadAction<{ loading: boolean; postId: string | null }>
    ) => {
      state.editingPost.loading = action.payload.loading;
      state.editingPost.postId = action.payload.postId;
    },
  },
});

export const {
  setPostLoading,
  setCommentLoading,
  setUserLoading,
  setDraftLoading,
  setEditingPostLoading,
} = loadingSlice.actions;
export default loadingSlice.reducer;
